import { FunctionComponent } from "react";
import StackComponent from "../../../../components/stack";
import PeopleAltRoundedIcon from '@mui/icons-material/PeopleAltRounded';

interface CelulaStackComponentProps {
  objectWithValues: any[]
}

const CelulaStackComponent: FunctionComponent<CelulaStackComponentProps> = ({ objectWithValues }) => {

  return (<>
    <StackComponent
      icon={<PeopleAltRoundedIcon />}
      title="Células"
      total={`${objectWithValues?.length}`}
      valueActual={`Novas 0`}
    />
  </>);
}

export default CelulaStackComponent;
